import { FC } from 'react';
import { PageTitle, PageLink } from '../../../rbts/layout/core';
import { View } from './components/View';

const EventosPage: FC = () => {
  const widgetsBreadCrumbs: Array<PageLink> = [];

  return (
    <>
      <PageTitle breadcrumbs={widgetsBreadCrumbs}>Eventos</PageTitle>
      <View />
    </>
  );
};

export { EventosPage };
